module.exports = __webpack_public_path__ + "d6c3abdad214be514522c35855678b10.svg";